<template>
  <div id="app" :class="{ 'auth-screen': $route.path.toLowerCase() === '/login' }">
    <!-- ຊ່ອນ Navbar ຖ້າຢູ່ໜ້າ Login ເພື່ອຄວາມສະອາດຕາ -->
    <!-- Router View ໂດຍບໍ່ມີ Row/Col ຫຸ້ມ ເພື່ອໃຫ້ Layout ຂອງແຕ່ລະໜ້າ (Dashboard/List) ຈັດການເອງໄດ້ເຕັມທີ່ -->
    <router-view />
  </div>
</template>

<script>
export default {
    data() {
        return {
            user:[]
        }
    },
    methods: {
        exit() {
            localStorage.removeItem("Login");
            this.$router.push("/login");
        },
        settop() {
            document.body.scrollTop = 0
        }
    },

}
</script>

<style>
#app {
    font-family: 'Noto Sans Lao Regular', 'Phetsarath OT';
    color: #2c3e50;
    min-height: 100vh;
    background-color: #f4f7f6; /* ສີພື້ນຫຼັງທີ່ທັນສະໄໝ */
}

.main-navbar {
    z-index: 1100; /* ໃຫ້ຢູ່ເທິງ Sidebar ຖ້າມີການ overlap */
}

.auth-screen {
    background-color: #ffffff !important;
}

.navbar-brand span {
    letter-spacing: 0.5px;
}
</style>
